import { useState } from 'react'
import Apicall from '../api/Apicall';

export const useRecoverPassword = () => {

    const [resultChangePass, setResultChangePass] = useState(null);

    const sentChangePass = async ({data, app, user}) => {

        try {
            const datas = { "idAcceso": data.newPass, "accesoActual": data.currentPass, "language": user.idioma };
            const result = await Apicall({
                url: `${app.urlLogin}/userLogin/notifyPasswordChangeLogged`,
                data: datas, user, app,
                headers: {
                    'Content-Type': 'application/json'
                },
                noKeyClient : true
            });

            if (result.data) {
                setResultChangePass(result.data);
            }

        } catch (error) {
            console.log(error)
            return false;
        }
    }

    return {
        sentChangePass,
        resultChangePass
    }
}